import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import AutoQuery from "servicestack/auto-query/auto-query";

export default class OrderEditableKitController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = cartConfig;
		$ctrl.order = Object.assign({}, options.model, options.order);
		$ctrl.product = options.product;
		$ctrl.title = "Add " + options.product.id;
		$ctrl.subTitle = "Kit Components";
		$ctrl.item = options.cartItem;
		$ctrl.shipOn = $ctrl.item.shipOn;
		$ctrl.results = [];
		$ctrl.parts = JSON.parse($ctrl.product.meta.Components);
		//console.info("BL*** components = " + JSON.stringify($ctrl.parts));
	}
	save() {
		const $ctrl = this;
		$ctrl.lines = [];
		$ctrl.bus.validationErrors = [];


		let result = $ctrl.results.reduce((accumulatorPromise, part) => {
			return accumulatorPromise.then(() => {
				if (part.qty > 0) {
					//from kit always add as new item
					//var item = part.isInCart() ? $ctrl.$cart.itemIndex[part.id] : {};
					var item = {};
					item.qtyPurchased = item.quantity = part.qty;
					item.notes = part.notes;
					if (!$ctrl.config.useComponentShipDate) item.shipOn = $ctrl.shipOn;
					item.fromKit = true;
					if (part.priceOverride !== part.price) {
						item.priceOverride = part.priceOverride;
					}
					//from kit always add as new item
					//return part.isInCart() ? $ctrl.$cart.changeOptions(item, part) : $ctrl.$cart.addItem(item, part, true, '', true);
					return $ctrl.$cart.addItem(item, part, true,'',true);
				}
			});
		}, Promise.resolve());
		result.then(() => {
			$ctrl.$cart.load();
			$ctrl.$close();
		});


		//$ctrl.results.forEach(function (part, index) {
		//	if (part.qty > 0) {
		//		var item = {};
		//		item.qtyPurchased = item.quantity = part.qty;
		//		item.product = part;
		//		$ctrl.lines.push(item);
		//	}
		//});

		//if ($ctrl.lines.length > 0) {
		//	$ctrl.$cart.addMultipleItems($ctrl.lines).then(() => {
		//		$ctrl.$cart.load($ctrl.$cart.id);
		//		$ctrl.$close();
		//	});
		//}
	}
}
